<div class="modal-body">
  <h3 class="text-center">Third-party Licenses</h3>
  <pre class="m-b-0">{{ text }}</pre>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default btn-wide" (click)="modal.hide()">Close</button>
</div>
